import React from "react";
import { ApolloProvider } from "@apollo/react-hooks";
import ApolloClient from "apollo-boost";
import { BrowserRouter as Router, Route } from "react-router-dom";
import Application from "./views/Application";
import { FindNumber } from "./utils/FindNumber";

export const client = new ApolloClient({
  uri: process.env.REACT_APP_MAIN_API,
  credentials: "include"
});

const App = () => {
  return (
    <ApolloProvider client={client}>
      <Router>
        <Route path="/:id" component={FindNumber} />
        <Application />
      </Router>
    </ApolloProvider>
  );
};

export default App;
